/** Cmd+F (mac) / Ctrl+F (win/linux), excluding combos like Ctrl+Alt+F. */
export function isFindShortcut(event: KeyboardEvent): boolean {
  return (
    (event.metaKey || event.ctrlKey) &&
    !event.altKey &&
    (event.key === 'f' || event.key === 'F')
  );
}
